import { Tab, Tabs, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { TabValue } from "../types/types";
import { Link } from "react-router-dom";

type Props = {
  value: TabValue;
  handleTabChange: (newValue: TabValue) => void;
  getPath: (tab: TabValue) => { pathname: string; search: string };
};

const TabsComponent = ({ value, handleTabChange, getPath }: Props) => {
  const { t } = useTranslation("customers");

  const tabs = [
    "basicInfo",
    "workLocations",
    "orderTemplates",
    "customerCostCenters",
    "contracts",
    "users",
    "pools",
  ];

  return (
    <Tabs
      value={value}
      onChange={(e, newValue) => handleTabChange(newValue)}
      textColor="primary"
      sx={{
        borderBottom: "1px solid #4A1D9C1F",
        "& .MuiTab-root": {
          textTransform: "none",
          fontWeight: 700,
          "&.Mui-selected": {
            "& span": {
              color: "primary.main",
            },
          },
        },
      }}
    >
      {tabs.map((tab) => (
        <Tab
          to={getPath(tab as TabValue)}
          component={Link}
          key={tab}
          value={tab}
          label={
            <Typography variant="header" color="textSecondary">
              {t(tab)}
            </Typography>
          }
        />
      ))}
    </Tabs>
  );
};

export default TabsComponent;
